import React, { useState, useEffect, useRef } from "react";
import { InputGroup, FormControl, Button } from "react-bootstrap";
import { useWorkspace } from "../../../contexts/WorkspaceContext";
import PromtInputFileUploader from "./PromtInputFileUpliader";
import { useUI } from "../../../contexts/UIContext";
import axios from "axios";
import { useCreditRecharge } from "../../../contexts/CreditRechageContext";
import sourceUrl from "../../../api/Source.api";
import ServicesForDefaultWindow from "./ServicesForDefaultWindow";
import { prompt_Input_bg_color_for_darkmode } from "../../../constants/colors";
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { trackSearchInteraction } from "../../../config/analytics";


const PromptInput = () => {
  const [files, setFiles] = useState([]);
  const [fileProcessing,setFileProcessing] = useState(false);
  const [theme,setTheme] = useState(localStorage.getItem("theme"));
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const token  = localStorage.getItem('token');
  const { toggleTheme, currentTheme } = useUI();
  const { showCreditRecharge, setShowCreditRecharge } = useCreditRecharge();
  const {
    Today,
    currentThread,
    setCurrentThread,
    waitThread,
    setWaitThread,
    sendMessage,
    checkUrlStatus,
    threadFiles,
    setSending,
    sending,
    threadId,
    InvokeMatrixApi,
    setCurrentHistoryId
  } = useWorkspace(); // Access sendPrompt function from WorkspaceContext
  const textareaRef = useRef(null);

  const fetchAllHistory = async() => {
    try {
      const res = await axios.get(`${sourceUrl}/chat/summary`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      console.log("print from summary",res)
      console.log(res);

      if (res.data.status) { // Check if the response status is true
        const { today, yesterday, this_week, this_month } = res.data.data;
        if(today.length ){
          // localStorage.setItem('current_history_id',today[0].id);
          if(Today.length && Today.length < today.length){
            setCurrentHistoryId(today[0].id);
          }
          
        }
      } else {
        // Handle API response error
      }
      // ==========================Invoke matrix api ===================================================
      // Invoke matrix API
        await InvokeMatrixApi(res, res, 'POST',threadId, 'summary', {});
      // ===============================================================================================
    } catch (error) {
      console.error("Error fetching history:", error);
      // ==========================Invoke matrix api ===================================================
        // Invoke matrix API
        await InvokeMatrixApi(error , error.data, 'POST',threadId, 'summary', {});
      // ===============================================================================================
      // Handle fetch error
    }
  }

  // useEffect(() => {
  //   fetchAllHistory();
  // }, [ currentThread])
  

  const [input, setInput] = useState("");

  useEffect(() => {
    setTheme(currentTheme);
  }, [currentTheme])
  
  
  

  useEffect(() => {
    setFiles(threadFiles);
  }, [threadFiles]);
  
  useEffect(() => {
    // let intervalId;
  
    // const checkFileStatus = async () => {
    //   const processedFiles = await Promise.all(
    //     files.map(async (file) => {
    //     const url = file.url ;
    //     const fileId = file.fileId ;
    //       // const res = await checkUrlStatus(file.url);
    //       // return res;
    //       const res = await fetch("https://www.modalx.ai/status", {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //           "Authorization":`Bearer ${token}`
    //         },
    //         body: JSON.stringify({ fileId, url }),
    //       });
    //       return res.status === 200 || res.status === 500 ;
    //     })
    //   );
  
    //   const allFilesProcessed = processedFiles.every((res) => res);
  
    //   if (allFilesProcessed) {
    //     clearInterval(intervalId);
    //   }
  
    //   setFileProcessing(allFilesProcessed);
    // };
  
    // // Run once initially
    // checkFileStatus();
  
    // // Set interval to periodically check file status
    // intervalId = setInterval(checkFileStatus, 3000);
  
    // return () => {
    //   clearInterval(intervalId);
    //   setFileProcessing(false);
    // };
    const isAnyFileProcessing = files.some(file => file && file.status === 'processing');
    setFileProcessing(isAnyFileProcessing);
  }, [files]);

  // console.log("aaaaaaaaaaaaaaaaaaaaaaa",theme);

  // Ref to keep interval IDs
  const intervalRef = useRef({});

  // Listen for changes in the currentThread, set interval accordingly
  useEffect(() => {
    console.log("currentThread changed");
    currentThread.forEach(async (message) => {
      if (
        message.sender === "modalX" &&
        message.file?.status === "processing" &&
        !intervalRef.current[message.file.url]
      ) {
        console.log("Setting interval for", message.file.url);
        intervalRef.current[message.file.url] = setInterval(async () => {
          console.log("Checking status for", message.file.url);
          const isProcessed = await checkUrlStatus(message.file.url);

          if (isProcessed) {
            const currRes = await fetch(`${sourceUrl}/status`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Authorization":`Bearer ${token}`
              },
              body: JSON.stringify({ fileId:message.file.id, url:message.file.url }),
            });
            const responseData = await currRes.json();
           
            if(responseData.data.status === "completed"){
              setCurrentThread((prevThread) =>
                prevThread.map((msg) =>
                  msg.sender === "modalX" && msg.file?.url === message.file.url
                    ? { ...msg, file: { ...msg.file, status: "processed" } }
                    : msg
                )
              );
            }
            else{
              setCurrentThread((prevThread) =>
                prevThread.map((msg) =>
                  msg.sender === "modalX" && msg.file?.url === message.file.url
                    ? { ...msg, file: { ...msg.file, status: "failed" } }
                    : msg
                )
              );
            }
            console.log("File processed:", message.file.url);
            clearInterval(intervalRef.current[message.file.url]);
            delete intervalRef.current[message.file.url]; // Clean up for this file URL

            
          }
        }, 5000);
      }
    });

    return () => {
      // Stop all intervals
      Object.values(intervalRef.current).forEach(clearInterval);
      intervalRef.current = {}; // Clear all interval IDs
    };
  }, [currentThread, setCurrentThread, checkUrlStatus]);

  

  // Handler for the input change
  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const findUrl = (msg) => {
    const urlRegex = /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt))/g;
    const match = urlRegex.exec(msg);
    return match ? match[1] : null;
  };

  const getFileFormat = (url) => {
    // Extract the file extension from the URL
    const parts = url.split('.');
    if (parts.length > 1) {
      return parts[parts.length - 1]; // Return the last part as the file format
    } else {
      return ''; // Return empty string if no file extension found
    }
  };

  // Handler for the input submit
  const handleSubmit = async () => {
    trackSearchInteraction(input);
    setSending(true);
    setWaitThread(true);
    if (input.trim()) {
      const latestEntry = { sender: "user", content: input };
      setInput(""); // Reset input field
      setCurrentThread((prevThread) => [...prevThread, latestEntry]);
      const entryResponse = await sendMessage(latestEntry).catch(console.error);
      if (entryResponse) {
        // Check if entryResponse contains a daily limit exceeded message
        if (
          entryResponse &&
          entryResponse.content &&
          findUrl(entryResponse.content) &&
          findUrl(entryResponse.content).includes("dailylimitexceeded")
        ) {
          // Determine the file format from the URL (assuming findUrl() returns the URL)
          const fileFormat = getFileFormat(findUrl(entryResponse.content));
  
          // Prepare the response message
          const responseMessage = {
            content: `Hi there,\n\nIt looks like you’ve reached your daily limit for generating `+ fileFormat +` files. We’re really sorry about that! We know how important uninterrupted access is for you.\n\nTo keep enjoying all the great benefits and have a seamless experience, we’d love for you to consider upgrading to our premium plan.\n\nThank you so much for your understanding and support. We truly value having you with us and are excited to continue providing you with the best service possible.\n\nWarm regards,\n\nThe ModalX Team`,
            sender: 'modalX'
          };
  
          // Update the current thread with the response message
          setCurrentThread((prevThread) => [...prevThread, responseMessage]);
          setShowCreditRecharge(true);
        } else {
          // If the response does not contain a daily limit exceeded message, proceed as usual
          setCurrentThread((prevThread) => [...prevThread, entryResponse]);
        }
        setSending(false);
      } else {
        // If there's no entryResponse, indicate processing failure
        setCurrentThread((prevThread) => [...prevThread, {content:"Unable to process your query!..",sender:'modalX'}]);
        setSending(false);
      }
    }
    setWaitThread(false);
  };
  
  
  // console.log("entryresponse_from_/message api ",currentThread)
  // Optional: Prevent form submit on Enter key
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  useEffect(() => {
    if (textareaRef.current) {

      textareaRef.current.style.height = "auto";

      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [input]);
  
  return (
    <div>
      <div style={{marginBottom:'10px', }}>
        <ServicesForDefaultWindow />
      </div>
      <p style={{margin:'auto',textAlign:'center',marginBottom:'20px',}}>Generate a summary of your content  in One-Click in any of the above formats</p>
      <InputGroup style={{maxWidth:'760px',margin:'auto',  }}>
      
      <Button style={{backgroundColor:theme === 'dark'?prompt_Input_bg_color_for_darkmode:'',borderRight:'transparent',
             borderTopLeftRadius:'16px',borderBottomLeftRadius:'16px',border:'none', }}>
          <PromtInputFileUploader />
          </Button>
        <FormControl
        ref={textareaRef}
        
          as="textarea"
          placeholder={
            !sending && !fileProcessing ? 'What would you like to do today?' : (fileProcessing? 'Your file is processing.. How can I help you?' : (sending ? "Generating the response...":''))
          }
          
          disabled={sending}
          // style={{
          //   resize: "none",
          //   overflow: "hidden",
          //   height: "auto",
          //   maxHeight: "35vh",
          //   backgroundColor:theme === 'dark'?prompt_Input_bg_color_for_darkmode:'',
          //   border:'none'
          // }}
          style={{
            resize: "none",
            // overflowY: "auto",
            maxHeight :  input.length > 50 ? '184px' :'60px',
            backgroundColor:theme === 'dark'?prompt_Input_bg_color_for_darkmode:'',
            border:'none',
            outline: 'none',
            boxShadow: 'none',
            scrollbarWidth: 'thin', // Firefox: doesn't allow showing only thumb,
            paddingTop : '18px'
            
  

            
          }}
          
          value={input}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          aria-label="Message input"
        />
 

        <Button
          variant="outline-secondary"
          onClick={handleSubmit}
          disabled={waitThread || fileProcessing }
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderLeft: "none",
            color: waitThread || fileProcessing?'grey':'white',
            borderColor:theme === 'dark'?'#6c757d':'#e0dcdc',
            backgroundColor:theme === 'dark'?prompt_Input_bg_color_for_darkmode:'',
            borderTopRightRadius:'16px',
            borderBottomRightRadius:'16px',
            border:'none'
          }}
          className="my-0 py-0"
        >
          <SendOutlinedIcon />
        </Button>
      </InputGroup>
    </div>
  );
};

export default PromptInput;



// import React, { useState, useEffect, useRef } from "react";
// import { InputGroup, FormControl, Button } from "react-bootstrap";
// import { useWorkspace } from "../../../contexts/WorkspaceContext";

// const PromptInput = () => {
//   const {
//     currentThread,
//     setCurrentThread,
//     waitThread,
//     setWaitThread,
//     sendMessage,
//     checkUrlStatus,
//   } = useWorkspace(); // Access sendPrompt function from WorkspaceContext
//   const [input, setInput] = useState("");

  

//   // Ref to keep interval IDs
//   const intervalRef = useRef({});

//   // Listen for changes in the currentThread, set interval accordingly
//   useEffect(() => {
//     console.log("currentThread changed");
//     currentThread.forEach(async (message) => {
//       if (
//         message.sender === "modalX" &&
//         message.file?.status === "processing" &&
//         !intervalRef.current[message.file.url]
//       ) {
//         console.log("Setting interval for", message.file.url);
//         intervalRef.current[message.file.url] = setInterval(async () => {
//           console.log("Checking status for", message.file.url);
//           const isProcessed = await checkUrlStatus(message.file.url);

//           if (isProcessed) {
//             console.log("File processed:", message.file.url);
//             clearInterval(intervalRef.current[message.file.url]);
//             delete intervalRef.current[message.file.url]; // Clean up for this file URL

//             setCurrentThread((prevThread) =>
//               prevThread.map((msg) =>
//                 msg.sender === "modalX" && msg.file?.url === message.file.url
//                   ? { ...msg, file: { ...msg.file, status: "processed" } }
//                   : msg
//               )
//             );
//           }
//         }, 5000);
//       }
//     });

//     return () => {
//       // Stop all intervals
//       Object.values(intervalRef.current).forEach(clearInterval);
//       intervalRef.current = {}; // Clear all interval IDs
//     };
//   }, [currentThread, setCurrentThread, checkUrlStatus]);

//   // Handler for the input change
//   const handleInputChange = (e) => {
//     setInput(e.target.value);
//   };

//   // Handler for the input submit
//   const handleSubmit = async () => {
//     setWaitThread(true);
//     if (input.trim()) {
//       const latestEntry = { sender: "user", content: input };
//       setInput(""); // Reset input field
//       setCurrentThread((prevThread) => [...prevThread, latestEntry]);
//       const entryResponse = await sendMessage(latestEntry).catch(console.error);
//       if (entryResponse) {
//         setCurrentThread((prevThread) => [...prevThread, entryResponse]);
//       }
//     }
//     setWaitThread(false);
//     // here add the functionality to check url status and update it in the currentThread
//   };

//   // Optional: Prevent form submit on Enter key
//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handleSubmit();
//     }
//   };

//   return (
//     <InputGroup>
//       <FormControl
//         as="textarea"
//         placeholder={
//           waitThread ? "Working on it..." : "What would you like to do today?"
//         }
//         disabled={waitThread}
//         style={{
//           resize: "none",
//           overflow: "hidden",
//           height: "auto",
//           maxHeight: "35vh",
//         }}
//         value={input}
//         onChange={handleInputChange}
//         onKeyDown={handleKeyDown}
//         aria-label="Message input"
//       />
//       <Button
//         variant="outline-secondary"
//         onClick={handleSubmit}
//         disabled={waitThread}
//         style={{
//           borderTopLeftRadius: 0,
//           borderBottomLeftRadius: 0,
//           borderLeft: "none",
//         }}
//         className="my-0 py-0"
//       >
//         <i className="bi bi-arrow-up-circle-fill fs-4" />
//       </Button>
//     </InputGroup>
//   );
// };

// export default PromptInput;